exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table th[data-v-2dff2756]{background-color:#f8f9fa;border-top:none}.table td[data-v-2dff2756]{vertical-align:middle}.bg-light[data-v-2dff2756]{background-color:#f8f9fa!important}.text-muted[data-v-2dff2756]{color:#6c757d!important}.h6[data-v-2dff2756]{font-size:1rem;font-weight:600;margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2dff2756","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/common/VehicleChallanList.vue
// module id = 1473
// module chunks = 0